var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-container',[_c('b-row',[_c('b-col',[_vm._v("\n        Embed Analystic\n      ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }